/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArElementArrowFromJSON, StreemApiArElementArrowToJSON, StreemApiArElementMeasurementFromJSON, StreemApiArElementMeasurementToJSON, StreemApiArElementModel3dFromJSON, StreemApiArElementModel3dToJSON, StreemApiArElementTextFromJSON, StreemApiArElementTextToJSON, } from './';
export function StreemApiArElementFromJSON(json) {
    return StreemApiArElementFromJSONTyped(json, false);
}
export function StreemApiArElementFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'arrow': !exists(json, 'arrow') ? undefined : StreemApiArElementArrowFromJSON(json['arrow']),
        'measurement': !exists(json, 'measurement') ? undefined : StreemApiArElementMeasurementFromJSON(json['measurement']),
        'model3d': !exists(json, 'model3d') ? undefined : StreemApiArElementModel3dFromJSON(json['model3d']),
        'text': !exists(json, 'text') ? undefined : StreemApiArElementTextFromJSON(json['text']),
    };
}
export function StreemApiArElementToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'arrow': StreemApiArElementArrowToJSON(value.arrow),
        'measurement': StreemApiArElementMeasurementToJSON(value.measurement),
        'model3d': StreemApiArElementModel3dToJSON(value.model3d),
        'text': StreemApiArElementTextToJSON(value.text),
    };
}
//# sourceMappingURL=StreemApiArElement.js.map